import './Badge.scss'

type BadgeProps = {
  text: string
  variant?: BadgeVariation
}

/**
 * Communicates status information to the user.
   Ex: Credit Card Status, Appointment Status, etc.
 * @param text The string you want rendered in the badge. Usually conditional as a prop.
 * @param variant Determines Badge and text color. 'success', 'error', 'neutral', 'pending'
 * @author Brendan Roman
 */
export const Badge: React.FC<BadgeProps> = ({ text, variant = 'success' }) => {
  return (
    <div className={`Badge Badge--${variant.toLowerCase()}`}>
      {text.toUpperCase()}
    </div>
  )
}

export default Badge
